// RequireAuth.js
import { useEffect } from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { Auth } from 'aws-amplify'
import { checkIfAccountIsAdmin } from '../helper'

export function RequireAuth({ children }) {
  const location = useLocation()
  const { route, user } = useAuthenticator((context) => [
    context.route,
    context.user
  ])

  const isAuthenticated = route === 'authenticated'
  const isAdmin = isAuthenticated && checkIfAccountIsAdmin(user)

  useEffect(() => {
    if (isAuthenticated && !isAdmin) {
      Auth.signOut().catch((err) => console.error(err)) // eslint-disable-line
    }
  }, [isAuthenticated, isAdmin])

  if (!isAuthenticated) {
    return <Navigate to='/login' state={{ from: location }} replace />
  }
  if (!isAdmin) {
    return (
      <Navigate
        to='/login'
        state={{ from: location, reason: 'not_admin' }}
        replace
      />
    )
  }
  return children
}
